var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUkeu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 76,
    viewBox: "0 0 172 76",
    width: 172,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 75.866h171.216v-75.866h-171.216z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.438 46.2669c-2.524 2.044-5.524 2.972-8.559 2.972-7.695 0-11.879-5.591-11.879-11.21 0-5.684 4.055-11.401 12.263-11.401 2.81 0 5.269.8 7.153 1.726v3.864c-1.629-.895-4.758-2.044-7.217-2.044-5.397 0-8.015 3.737-8.015 7.694 0 5.206 3.768 7.824 7.888 7.824 2.267 0 4.599-.764 6.513-2.298z",
    fill: "#0047c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.07 48.854h-4.024v-9.132h-10.25v9.132h-4.024v-21.907h4.024v9.231h10.25v-9.231h4.024z",
    fill: "#0047c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.795 36.178h10.25v3.544h-10.25",
    fill: "#fb471f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.526 48.854h-3.353l-12.422-15.456h-.096l.191 5.398v10.058h-3.991v-21.907h3.385l12.391 15.456h.094l-.191-5.396v-10.06h3.992z",
    fill: "#0047c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.173 48.854-12.421-15.456h-.097l-.415-6.451 12.391 15.456h.094z",
    fill: "#fb471f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0047c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.116 53.574v21.907h13.572v-3.545h-9.548v-5.586h7.314v-3.546h-7.314v-5.684h8.974v-3.546z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.3906 67.9763c0 5.013-4.311 7.889-8.75 7.889-4.438 0-8.75-2.876-8.75-7.889v-14.403h4.024v13.381c0 3.385 1.757 5.364 4.726 5.364 2.906 0 4.726-1.947 4.726-5.364v-13.381h4.024zm12.5317-10.8564h-3.513v5.874h3.513c2.362 0 3.353-1.5 3.353-2.969 0-1.532-.958-2.905-3.353-2.905zm9.739 18.361h-5.109l-5.365-8.943h-2.778v8.943h-4.024v-21.908h8.207c4.534 0 6.642 3.355 6.642 6.421 0 2.298-1.436 5.013-3.959 6.003l3.64 6.132c.606.988 1.341 1.181 1.981 1.181h.765zm5.6956-10.8903c0 5.367 3.864 7.728 7.472 7.728 3.609 0 7.473-2.361 7.473-7.728 0-5.365-3.897-7.79-7.473-7.79-3.577 0-7.472 2.425-7.472 7.79m19.129-.031c0 5.653-4.024 11.306-11.657 11.306-7.632 0-11.656-5.653-11.656-11.306s4.024-11.306 11.656-11.306c7.633 0 11.657 5.653 11.657 11.306m11.7987-7.4397h-3.513v6.066h3.513c2.363 0 3.353-1.565 3.353-3.034 0-1.532-.958-3.032-3.353-3.032m.415 9.611h-3.928v8.75h-4.023v-21.908h8.206c4.535 0 6.642 3.417 6.642 6.482 0 3.259-2.299 6.676-6.897 6.676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.248 53.574v21.907h13.572v-3.545h-9.55v-5.586h7.315v-3.546h-7.315v-5.684h8.975v-3.546z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.4409 14.7229c0 5.013-4.311 7.889-8.75 7.889-4.438 0-8.75-2.876-8.75-7.889v-14.403h4.024v13.381c0 3.385 1.757 5.364 4.726 5.364 2.906 0 4.726-1.947 4.726-5.364v-13.381h4.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.339 22.228h4.024v-21.907h-4.024z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.028.32v10.061l.19 5.395h-.094l-12.389-15.456h-3.386v21.907h3.991v-10.058l-.191-5.397h.095l12.422 15.455h3.353v-21.907z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.5669 9.262 1.246-3.671h.064l1.245 3.671 1.917 4.887h-6.386zm-.479-8.942-8.623 21.908h4.025l1.82-4.598h9.069l1.822 4.598h4.024l-8.623-21.908zm-23.4214 48.9186c-7.695 0-11.879-5.591-11.879-11.241 0-5.653 4.055-11.371 12.263-11.371 2.809 0 5.269.801 7.153 1.727v3.863c-1.63-.894-4.759-2.043-7.217-2.043-5.397 0-8.015 3.737-8.015 7.694 0 4.153 2.714 7.824 7.951 7.824 1.437 0 3.066-.35 4.504-1.084v-3.417h-5.143v-3.544h9.133v8.462c-2.715 2.394-6.482 3.13-8.75 3.13m57.7998 0c-7.695 0-11.879-5.591-11.879-11.241 0-5.653 4.055-11.371 12.262-11.371 2.81 0 5.27.801 7.154 1.727v3.863c-1.63-.894-4.759-2.043-7.217-2.043-5.397 0-8.015 3.737-8.015 7.694 0 4.153 2.714 7.824 7.951 7.824 1.437 0 3.066-.35 4.503-1.084v-3.417h-5.143v-3.544h9.134v8.462c-2.713 2.394-6.482 3.13-8.75 3.13",
    mask: "url(#a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m117.644 48.855h4.023v-21.907h-4.023z",
    fill: "#fb471f",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.327 48.854h-3.353l-12.422-15.456h-.096l.191 5.398v10.058h-3.991v-21.907h3.385l12.391 15.456h.095l-.192-5.396v-10.06h3.992z",
    fill: "#0047c7",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.6567 40.7747-1.917-4.886-1.245-3.671h-.064l-1.246 3.671-1.914 4.886zm7.186 8.079h-4.024l-1.82-4.597h-9.07l-1.82 4.597h-4.024l8.623-21.907h3.512zm7.7779-28.7978h-.765c-.538 0-1.244-.094-1.816-.714l-6.695-9.123 7.6-7.79-2.395-2.429-10.091 10.412v-10.092h-4.024v21.907h4.024v-6.992l2.164-2.229 6.888 9.221h.018 4.629.463z",
    fill: "#0047c7",
    mask: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkeu);
export default __webpack_public_path__ + "static/media/ukeu.33dd9127ee9447a468314a295b20a700.svg";
export { ForwardRef as ReactComponent };